import { render, staticRenderFns } from "./EstimationFrais.vue?vue&type=template&id=83ce8c18"
import script from "./EstimationFrais.vue?vue&type=script&lang=js"
export * from "./EstimationFrais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports